import { render, staticRenderFns } from "./BTB_INSERT_TEMPLATE.vue?vue&type=template&id=2eb4bec8&lang=pug"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports